export default __webpack_public_path__ + "static/media/Research.c9ff9202.jpg";